import React, { useState } from "react";
import { FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import { login } from "../api/consumerService"; // adjust path as needed

const LoginForm = ({ onLogin }) => {
    const [loginName, setLoginName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            debugger;
            const res = await login({ loginName, password }); // call API
            if (res.data.data.token) {
                localStorage.setItem("Token", res.data.data.token); // store token
                localStorage.setItem("User", res.data.data.loginName); // 👈 Save loginName
                onLogin && onLogin(res.data.data.loginName); // 👈 Pass to parent
            } else {
                setError("Login failed: Token not received");
            }
        } catch (err) {
            setError("Invalid credentials");
            console.error("Login error:", err);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-100 overflow-hidden px-4">
            <form
                onSubmit={handleSubmit}
                className="w-full max-w-md bg-white p-8 shadow-lg rounded-xl space-y-6"
            >
                <div className="flex justify-center mb-4">
                    <img
                        src="/sv.png"
                        alt="Company Logo"
                        className="h-40 object-contain"
                    />
                </div>
                <h3 className="text-center text-lg font-medium text-gray-600 mb-4">
                    Consumer Management System
                </h3>

                <h2 className="text-2xl font-semibold text-center text-gray-800">
                    Login
                </h2>

                {error && (
                    <div className="flex items-start gap-2 text-red-600 bg-red-100 border border-red-300 rounded-md p-3 text-sm">
                        <FiAlertCircle className="mt-0.5" />
                        <span>{error}</span>
                    </div>
                )}

                <div className="flex flex-col">
                    <label className="text-sm text-gray-700 mb-1">Login Name</label>
                    <input
                        type="text"
                        value={loginName}
                        onChange={(e) => setLoginName(e.target.value)}
                        required
                        className="px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                <div className="flex flex-col">
                    <label className="text-sm text-gray-700 mb-1">Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition"
                >
                    Login
                </button>
            </form>
        </div>
    );
};

export default LoginForm;
